// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard, brandingGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable().optional(),
    customData: jsonObjectGuard.optional(),
    isMfaRequired: z.boolean().optional(),
    branding: brandingGuard.optional(),
    parentOrganizationId: z.string().max(21).nullable().optional(),
    depth: z.number().optional(),
    displayOrder: z.number().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable(),
    customData: jsonObjectGuard,
    isMfaRequired: z.boolean(),
    branding: brandingGuard,
    parentOrganizationId: z.string().max(21).nullable(),
    depth: z.number(),
    displayOrder: z.number(),
    createdAt: z.number(),
});
export const Organizations = Object.freeze({
    table: 'organizations',
    tableSingular: 'organization',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        name: 'name',
        description: 'description',
        customData: 'custom_data',
        isMfaRequired: 'is_mfa_required',
        branding: 'branding',
        parentOrganizationId: 'parent_organization_id',
        depth: 'depth',
        displayOrder: 'display_order',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'name',
        'description',
        'customData',
        'isMfaRequired',
        'branding',
        'parentOrganizationId',
        'depth',
        'displayOrder',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
